<template>
  <router-view></router-view>
</template>

<script>
var animate = document.getElementsByClassName('animate');
document.addEventListener('scroll',function(){
  //滚动条高度+视窗高度 = 可见区域底部高度
  var visibleBottom = window.scrollY + document.documentElement.clientHeight;
  //可见区域顶部高度
  var visibleTop = window.scrollY;
  for (var i = 0; i < animate.length; i++) {
    var centerY = animate[i].offsetTop + (animate[i].offsetHeight/2);
    if(centerY > visibleTop && centerY < visibleBottom){
      animate[i].classList.add("animate__animated",'animate__fadeInUp');
    }else{
      animate[i].classList.remove("animate__animated",'animate__fadeInUp');
    }
  }
})

import { defineComponent } from "vue";
import { onMounted } from 'vue';
export default defineComponent({
  name: "App",
  components: {},
  setup:function(){
    onMounted(() => {
        // onresize();
        // window.addEventListener('resize',onresize);
    })
    const onresize = ()=>{
        let clientWidth = document.documentElement.clientWidth;
        let pwidth = clientWidth;
        let prem = clientWidth/10;
        let html = document.getElementsByTagName("html")[0];
        let oWidth = document.body.clientWidth || document.documentElement.clientWidth;
        html.style.fontSize = oWidth / pwidth * prem + "px";
        console.log(pwidth, prem,oWidth / pwidth * prem + "px")
    }
    return {
      
    }
  }
});
</script>

<style>
  html{
    overflow-x: hidden;
  }
  html,body{
    margin:0px;
    padding: 0px;
    width: 10rem;
    height: 100vh;
  }
</style>